import { CallState, LoadingState } from '@lcs/shared/api';
import { createReducer, on } from '@ngrx/store';
import { onReset } from 'src/app/authentication/reset-reducer';
import { ExtensionGroupOption } from '../../extension-groups-register/models/extension-group-option.interface';
import { ExtensionOption } from '../../extension-register/models/extension-option.interface';
import { GetUserDetail_user } from '../queries/generated/GetUserDetail';
import * as UserDetailActions from './user-detail.actions';

export const userDetailFeatureKey = 'userDetail';

export interface State {
   user: GetUserDetail_user | null;
   extensions: ExtensionOption[];
   extensionGroups: ExtensionGroupOption[];
   callState: CallState;
}

export const initialState: State = {
   callState: LoadingState.Init,
   user: null,
   extensions: [],
   extensionGroups: [],
};

export const reducer = createReducer(
   initialState,
   onReset(initialState),
   on(UserDetailActions.userDetailLoad, UserDetailActions.userDetailCancel, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
         user: null,
      };
   }),
   on(UserDetailActions.loadUserDetailsSuccess, UserDetailActions.loadSystemUserDetailsSuccess, (state, action) => {
      const user: GetUserDetail_user = action.data;
      const extensions = action.extensions.items;
      const extensionGroups = action.extensionGroups.items;
      return {
         ...state,
         callState: LoadingState.Loaded,
         user: user,
         extensionGroups: extensionGroups,
         extensions: extensions,
      };
   }),
   on(UserDetailActions.loadUserDetailsFailure, (state, action) => {
      return {
         ...state,
         callState: action,
      };
   }),
   on(UserDetailActions.saveUserDetailFailure, UserDetailActions.userDetailAccessDenied, (state) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   })
);
